// extracted by mini-css-extract-plugin
module.exports = {"menu_text":"sidebar_menu_text__2dpt1"};